// frontend/src/App.jsx
import React from "react";

import RealtimeAssistant from "./components/RealtimeAssistant.jsx";

function App() {
  
  return (
    <div className="App">
       <RealtimeAssistant />
    </div>
  );
}

export default App;
